import { useContext, useState, useEffect } from 'react';
import Context from '../context';

/**
 * Custom hook to handle translations for UI components.
 * @param {Object} defaultStrings - Object with key-value pairs of default English strings.
 * @returns {Object} Translated strings.
 */
const useTranslate = (defaultStrings) => {
    const { languageCode, translateText } = useContext(Context);
    const [t, setT] = useState(defaultStrings);

    useEffect(() => {
        const translateEffect = async () => {
            if (!languageCode || languageCode === 'en') {
                setT(defaultStrings);
                return;
            }

            try {
                const keys = Object.keys(defaultStrings);
                const translatedValues = await Promise.all(
                    keys.map(key => translateText(defaultStrings[key], languageCode))
                );

                const nextT = {};
                keys.forEach((key, i) => {
                    nextT[key] = translatedValues[i];
                });
                setT(nextT);
            } catch (error) {
                console.error("Translation hook error:", error);
                setT(defaultStrings); // Fallback to English
            }
        };

        translateEffect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [languageCode, translateText]);

    return t;
};

export default useTranslate;
